import { Strategy } from '@/api';

export function isNameNotUnique(
  strategyName: string,
  existingStrategies: Strategy[]
): boolean {
  const name = strategyName.trim().toLowerCase();
  return (
    name !== '' &&
    existingStrategies.some((s) => s.name?.trim().toLowerCase() === name)
  );
}

export function isNameNotUniqueWithinFacility(
  facilityId: number,
  strategyName: string,
  existingStrategies: Strategy[]
): boolean {
  const facilityStrategies = existingStrategies.filter(
    (s) => s.facilityId === facilityId
  );
  return isNameNotUnique(strategyName, facilityStrategies);
}
